import React, { FC } from 'react'
import Box from '@mui/material/Box'
import { IKnockStatus } from '@user/store/knockStatus/typings'
import { KnockStatusCard } from './KnockStatusCard'

interface KnockStatusListProps {
  statuses: IKnockStatus[]
  onEdit: (id: string) => void
  onDelete: (id: string) => void
}

export const KnockStatusList: FC<KnockStatusListProps> = ({
  statuses,
  onEdit,
  onDelete,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {statuses.map((status) => (
        <KnockStatusCard
          key={`status-${status.id}`}
          status={status}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </Box>
  )
}
